import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { ActivityCategory } from "@/modules/activities/viewmodels/ActivityCategory";

export const state = {
  activityCategories: [],
};

export const getters = Object.assign(
  {
    activityCategories: (state) => {
      return state.activityCategories;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/activity-categories",
    ActivityCategory,
    {
      AfterGetAll: (name, data) => {
        state.activityCategories = data;
        return state.activityCategories;
      },
      AfterDestroy: (name, data) => {
        let elementIndex = state.activityCategories.findIndex(
          (e) => e.id === data
        );

        if (elementIndex !== null) {
          state.activityCategories.splice(elementIndex, 1);
        }

        return data;
      },
    },
    {
      /**
       * Custom getters
       */
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/activity-categories",
  [],
  {}
);
